/**
 * <sunday-film>: the "How it's made" film (sections/sunday-m-made.liquid, mockup v88).
 * Silent; plays while at least 40% is on screen and pauses when it leaves (unless paused by hand).
 * The chapter under the playhead shows over the film and is marked in the list; a chapter tap jumps there.
 */
import { calm } from '@sunday/util';

class SundayFilm extends HTMLElement {
  connectedCallback() {
    const v = this.querySelector('video');
    const cap = this.querySelector('[data-cap]');
    const pp = this.querySelector('[data-pp]');
    const ch = [...this.querySelectorAll('[data-at]')];
    if (!v) return;
    let cur = 0;
    let held = false;
    const mark = () => {
      let i = 0;
      ch.forEach((b, j) => { if (v.currentTime >= Number(b.dataset.at) - 0.05) i = j; });
      if (i === cur) return;
      cur = i;
      if (cap) cap.textContent = ch[i].querySelector('span').textContent;
      ch.forEach((b, j) => b.setAttribute('aria-current', String(j === i)));
    };
    const paint = () => {
      pp.classList.toggle('sd-paused', v.paused);
      pp.setAttribute('aria-label', v.paused ? pp.dataset.play : pp.dataset.pause);
    };
    v.addEventListener('timeupdate', mark);
    v.addEventListener('play', paint);
    v.addEventListener('pause', paint);
    paint();
    pp.addEventListener('click', () => {
      if (v.paused) { held = false; v.play().catch(() => {}); } else { held = true; v.pause(); }
    });
    ch.forEach((b) => b.addEventListener('click', () => {
      v.currentTime = Number(b.dataset.at) + 0.05;
      held = false;
      v.play().catch(() => {});
    }));
    if (calm()) return;
    new IntersectionObserver((es) => es.forEach((e) => {
      if (e.isIntersecting && e.intersectionRatio >= 0.4) { if (!held) v.play().catch(() => {}); } else v.pause();
    }), { threshold: [0, 0.4] }).observe(v);
  }
}
if (!customElements.get('sunday-film')) customElements.define('sunday-film', SundayFilm);
